<template>
  <el-select
    v-loading="requestLoading"
    :value="value"
    @input="inputtt"
    :placeholder="placeholder"
    clearable
    :multiple="multiple"
    filterable
    @change="changeHanlder"
    :style="{
      width: width,
    }"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
      :disabled="!frozenCanSelect && item.frozen"
    >
      <span style="float: left">{{ item.name }}</span>
      <span
        :style="{ float: 'right', color: $jsTool.getColor('danger') }"
        v-if="item.frozen"
        >已冻结</span
      >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "Fmerpv2WebCommodityCategorySelect",
  props: {
    value: [Array, String],
    placeholder: {
      type: String,
      default: "请选择商品分类",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    containFrozen: {
      type: Boolean,
      default: true,
    },
    frozenCanSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      requestLoading: true,
      list: [],
    };
  },

  mounted() {
    this.flushList();
  },

  methods: {
    inputtt(e) {
      this.$emit("input", e || null);
    },
    changeHanlder(val) {
      this.$emit("change", val);
    },
    async flushList() {
      this.requestLoading = true;
      let requestRes = this.containFrozen
        ? await this.$api.commodityCategory_findListForManage({
            showFailMessage: false,
          })
        : await this.$api.commodityCategory_findListForSelect({
            showFailMessage: false,
          });
      if (requestRes && requestRes.success) {
        this.list = requestRes.data;
      }
      setTimeout(() => {
        this.requestLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CommodityCategorySelect.vue